import gsap from 'gsap';
import $ from 'jquery';

export default class HeroOutAnimation {
	constructor({ onComplete }) {
		this.timeline = null;
		this.onComplete = onComplete;
	}

	play() {
		// const titleDta = document.querySelectorAll('[data-dta-title]');
		// const titleDta = document.querySelectorAll('.dta:not(.is-hidden-component) [data-dta-title]');
		const animAisleContainer = document.querySelector('[data-anim-aisle="container"]');
		const animAisleLottie = animAisleContainer.querySelectorAll('[data-anim-aisle="lottie"]');
		const animAisleSubTitle = animAisleContainer.querySelector('[data-anim-aisle="subTitle"]');
		const animAisleTitle = animAisleContainer.querySelector('[data-anim-aisle="title"]');
		const animAisleText = animAisleContainer.querySelector('[data-anim-aisle="text"]');
		const animAisleImgLeft = animAisleContainer.querySelector('[data-anim-aisle="imgLeft"]');
		const animAisleBtns = animAisleContainer.querySelector('[data-anim-aisle="btns"]');

		if (this.timeline) {
			this.timeline.play();
			return;
		}

		this.timeline = gsap.timeline();

		this.timeline
			.to(
				animAisleSubTitle,
				{
					y: 50,

					duration: 0.7,
					opacity: 0,
					ease: 'power2.out',
					onComplete: () => {
						//console.log('is-seats-animation');
						$('body').addClass('is-seats-animation');
					},
				},
				0,
			)
			.to(
				animAisleTitle,
				{
					y: 40,

					duration: 0.7,
					opacity: 0,
					ease: 'power2.out',
				},
				0,
			)
			.to(
				animAisleText,
				{
					y: 30,

					duration: 0.7,
					opacity: 0,
					ease: 'power2.out',
				},
				0,
			)
			.to(
				animAisleBtns,
				{
					y: 20,

					duration: 0.7,
					opacity: 0,
					ease: 'power2.out',
				},
				0,
			)
			.to(
				animAisleImgLeft,
				{
					x: '-50vw',

					duration: 0.7,
					opacity: 0,
					ease: 'power2.out',
				},
				0,
			)
			.to(
				animAisleLottie,
				{
					duration: 0.5,
					opacity: 0,
					ease: 'power2.out',
				},
				0,
			)
			// .to(
			// 	titleDta,
			// 	{
			// 		y: 0,

			// 		duration: 1,
			// 		opacity: 1,
			// 		ease: 'power2.out',
			// 	},
			// 	0.7,
			// )
			.to(
				animAisleContainer,
				{
					duration: 0,
					onComplete: () => {
						$('body').addClass('is-seats-active');

						//console.log('animAisleContainer onComplete');

						this.onComplete();
					},
				},
				1.7,
			);
	}

	reset() {
		this.timeline.progress(0).pause();
	}
}
